import { render, staticRenderFns } from "./JobContentLoading.vue?vue&type=template&id=256c5f44"
import script from "./JobContentLoading.vue?vue&type=script&lang=js"
export * from "./JobContentLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports